<template>
<div >
  <div class="detailsTitle" >
       <h4>提单详情</h4>
       <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
    <div class="addressBox" style="margin-bottom:20px;" v-if="distributioned.length!=0">
       <h4 class="title" style="margin-bottom:10px;">
      <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>已配货物</span>
    </h4>
    <div class="yphw" v-for="item in distributioned" :key="item.billNo">
       <el-button type="primary" size="mini" class="vehMBtn" @click="lookGps(item)">车辆监控</el-button>
        <ul class="ydxq">
          <li>运单编号：{{item.wayNo}}</li>
          <li>司机姓名：{{item.dirverName}}</li>
          <li>联系电话：{{item.dirverMobile}}</li>
          <li>车牌号：{{item.vhcNo}}</li>
        </ul>
        <ul class="ydxq">
          <li>配货时间：{{item.createTime|dateFormat}}</li>
          <li v-if="productSource!=2">出库时间：{{item.outTime|dateFormat}}</li>
          <li>收货时间：{{item.receivingTime|dateFormat}}</li>
        </ul>
       <div class="searchBtnBox"  >
             <p style="font-size: 14px;">货物重量<span class="red">{{item.weight}}</span>吨</p>
             <p style="font-size: 14px;">货物件数<span class="red">{{item.productlist.length}}</span>件</p>
       </div>
      <el-table :data="item.productlist"    bordersize="mini"  class="table"  style="width: 100%" center  >
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column property="cargoBarcode" width="160" label="捆包号"></el-table-column>
          <el-table-column property="productTypeName" width="100" label="货物类型"></el-table-column>
          <el-table-column property="status" label="配货状态" >
          <template scope="scope">
            {{[ "未配货","已配货", "已出库","已收货"][scope.row.status-1]}}
          </template>
        </el-table-column>
          <el-table-column property="productName"  width="140"  label="品名"></el-table-column>
          <el-table-column property="model" width="120" label="材质"></el-table-column>
          <el-table-column property="specification" width="140"  label="规格"></el-table-column>
          <el-table-column property="weight" width="100" label="重量(吨)"></el-table-column>
          <el-table-column property="contractNumber" width="120" label="合同号"></el-table-column>
          <el-table-column property="agreementNumber" width="120" label="合约号"></el-table-column>
          <el-table-column property="cargoLocation" width="150" label="货位"></el-table-column>
          <el-table-column property="organizationName"  width="150" label="所在仓库"></el-table-column>
          <el-table-column  width="160" :formatter="dateFormat" property="enterTime" label="入库时间"></el-table-column>
      </el-table>
    </div>
    </div>
    <div class="addressBox"  v-if="noDistribution.length!=0">
    <h4 class="title" style="margin-bottom:10px;">
      <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>未配货物</span>
    </h4>
    <div>
       <div class="searchBtnBox" >
            <p style="font-size: 14px;">货物重量<span class="red">{{weight}}</span>吨</p>
            <p style="font-size: 14px;">货物件数<span class="red">{{noDistribution.length}}</span>件</p>
       </div>
      <el-table :data="noDistribution"    bordersize="mini"  class="table"  style="width: 100%" center  >
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column property="cargoBarcode" width="160" label="捆包号"></el-table-column>
          <el-table-column property="productTypeName" width="100" label="货物类型"></el-table-column>
          <el-table-column property="status" label="配货状态" >
          <template scope="scope">
            {{[ "未配货","已配货", "已出库","已收货"][scope.row.status-1]}}
          </template>
        </el-table-column>
          <el-table-column property="productName"  width="140"  label="品名"></el-table-column>
          <el-table-column property="model" width="120" label="材质"></el-table-column>
          <el-table-column property="specification" width="140"  label="规格"></el-table-column>
          <el-table-column property="weight" width="100" label="重量(吨)"></el-table-column>
          <el-table-column property="contractNumber" width="120" label="合同号"></el-table-column>
          <el-table-column property="agreementNumber" width="120" label="合约号"></el-table-column>
          <el-table-column property="cargoLocation" width="150" label="货位"></el-table-column>
          <el-table-column property="organizationName"  width="150" label="所在仓库"></el-table-column>
          <el-table-column  width="160" :formatter="dateFormat" property="enterTime" label="入库时间"></el-table-column>
      </el-table>
    </div>
    </div>
     <!-- 车辆监控-->
   <el-dialog  title="车辆监控"  :visible.sync="dialogVehM" width="1130px"  class="vehm" :fullscreen="true" :close-oni-click-modal="false" @close="closeMapDialog" :close-on-press-escape="false" center>
     <mapReal :map-data="mapData"  v-if="!mapData.isShowMap"></mapReal>
     <maphistory :map-data="mapData" v-if="mapData.isShowMap"></maphistory>
   </el-dialog>
</div>
</template>

<script>
import { sBillWayProductList } from '@/api/soc-stock'
import mapReal from '@/components/mapreal.vue'
import maphistory from '@/components/maphistory.vue'
export default {
  components: {
    mapReal,
    maphistory
  },
  data () {
    let id = this.$route.query.id
    let productSource = this.$route.query.productSource
    return {
      dialogVehM: false,
      mapData: '',
      id: id,
      weight: 0,
      productSource: productSource,
      noDistribution: [],
      distributioned: []
    }
  },
  created () {
    let that = this
    sBillWayProductList({ billId: this.id }).then(res => {
      this.noDistribution = res.noDistribution
      this.distributioned = res.distributioned
      this.noDistribution.forEach(function (item, n) {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
    })
  },
  mounted () {
  },
  methods: {
    // 查看定位
    lookGps (row) {
      this.dialogVehM = true
      this.mapData = row
      this.mapData.isShowMap = row.receivingTime
      this.mapData.type = 2
    },
    // 地图模态框关闭
    closeMapDialog () {
      this.mapData.isShowMap = 0
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = ''
      } else {
        str = t.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.dibu{
    display: flex;
    padding: 16px;
    flex-wrap: wrap;
    background: #cfddf9;

  }
  li{
        list-style: none;
        line-height: 32px;
            margin-right: 48px;
    font-size: 14px;
  }
.searchBtnBox{
  display: flex;
  p{
    margin-right: 10px;
  }
}
.yphw{
  margin-bottom:30px;
  position: relative;
}
.vehMBtn{
  position:absolute;
  right: 10px;
  top:10px;
}
</style>
